import clsx from 'clsx';

import Icon from '@ui-components/layout/Icon';
import Tooltip from '@ui-components/layout/Tooltip';

import styles from './Chip.module.css';

type ChipProps = {
  children: React.ReactNode;
  className?: string;
  // Makes the label a button, for a chip that opens what it is a label of
  onClick?: () => void;
  // Offers a button that removes the chip
  onRemove?: () => void;
  // Names that button for assistive technology, so it should always come with onRemove
  removeLabel?: string;
  // Explains that button to whoever points at it
  removeTooltip?: React.ReactNode;
};

// A small label for something applied or attached, such as a topic or a filter, that can be removed
const Chip = ({ children, className, onClick, onRemove, removeLabel, removeTooltip }: ChipProps) => {
  const removeButton = onRemove && (
    <button aria-label={removeLabel} className={styles.remove} type="button" onClick={onRemove}>
      <Icon id="x" aria-hidden />
    </button>
  );

  return (
    <span className={clsx(styles.chip, onClick && styles.clickable, className)}>
      {onClick ? <button aria-haspopup="dialog" className={styles.label} type="button" onClick={onClick}>{children}</button> : children}
      {removeButton && (removeTooltip ? <Tooltip content={removeTooltip}>{removeButton}</Tooltip> : removeButton)}
    </span>
  );
};

export default Chip;
